import { render, staticRenderFns } from "./GradingReportAiFeedback.vue?vue&type=template&id=97a8e4ba&scoped=true&"
import script from "./GradingReportAiFeedback.vue?vue&type=script&lang=js&"
export * from "./GradingReportAiFeedback.vue?vue&type=script&lang=js&"
import style0 from "./GradingReportAiFeedback.vue?vue&type=style&index=0&id=97a8e4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a8e4ba",
  null
  
)

export default component.exports